// AUTO-GENERATED BY FREESAIL CLI - DO NOT EDIT
// Re-run `freesail prepare catalog` to regenerate this file.

import type { FreesailComponentProps, FunctionImplementation } from '@freesail/react';
import type React from 'react';

export const includedComponents: Record<string, React.ComponentType<FreesailComponentProps>> = {
};

export const includedFunctions: Record<string, FunctionImplementation> = {
};
